/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { Actionable, Icon, Text, View } from '@az/starc-ui';
import VehicleSpecificImagesBannerStyles from './VehicleSpecificImagesBanner.module.scss';
import { VehicleMagnifiedIcon } from './VehicleMagnifiedIcon';
import { usePreferredVehicle } from '@/features/header/hooks/usePreferredVehicle';
import { useLabels } from '@/hooks/useLabels';

const labelMap = {
  title: 'label_ProductDetailsPage_VehicleSpecificImagesBanner_Title',
  subtitle: 'label_ProductDetailsPage_VehicleSpecificImagesBanner_Subtitle',
};

type VehicleSpecificImagesBannerProps = {
  onClick: () => void;
};

export default function VehicleSpecificImagesBanner({ onClick }: VehicleSpecificImagesBannerProps) {
  const preferredVehicle = usePreferredVehicle();
  const { title, subtitle } = useLabels(labelMap);

  return (
    <Actionable onClick={onClick}>
      <View
        direction="row"
        justify="space-between"
        align="center"
        padding={{ s: 2, m: [2, 4] }}
        className={VehicleSpecificImagesBannerStyles.container}
      >
        <View.Item className={VehicleSpecificImagesBannerStyles.textContainer}>
          <Text weight="bold" className={VehicleSpecificImagesBannerStyles.title}>
            {title} {preferredVehicle?.year} {preferredVehicle?.make} {preferredVehicle?.model}
          </Text>
          <Text className={VehicleSpecificImagesBannerStyles.subtitle}>{subtitle}</Text>
        </View.Item>
        <View.Item>
          <Icon svg={VehicleMagnifiedIcon} size={15} />
        </View.Item>
      </View>
    </Actionable>
  );
}
